import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=e0dd3ec8&scoped=true"
import script from "./Manufacturers.vue?vue&type=script&lang=js"
export * from "./Manufacturers.vue?vue&type=script&lang=js"
import style0 from "./Manufacturers.vue?vue&type=style&index=0&id=e0dd3ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dd3ec8",
  null
  
)

export default component.exports